
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export interface BtnProps {
    to?: ReactRouterDom.To;
    href?: string;
    target?: string;
    size?: "sm" | "md";
    children: React.ReactNode;
    style?: React.CSSProperties;
    variant?: "primary" | "dark" | "outline";
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

function addRipple(e: React.MouseEvent<HTMLElement>) {
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    const sz = Math.max(r.width, r.height) * 2;
    const span = document.createElement("span");
    span.className = styles["ripple"];
    Object.assign(span.style, {
        width: `${sz}px`,
        height: `${sz}px`,
        left: `${e.clientX - r.left - sz / 2}px`,
        top: `${e.clientY - r.top - sz / 2}px`,
    });
    el.appendChild(span);
    span.addEventListener("animationend", () => span.remove());
}

function Btn({ children, variant = "primary", size, to, href, target, onClick, style }: BtnProps) {

    const className = Classname.build(styles["btn"], styles[`btn-${variant}`], { [styles["btn-sm"]]: size === "sm" });
    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        addRipple(e);
        onClick?.(e);
    };

    if (to) {
        return (<ReactRouterDom.NavLink end to={to} target={target} className={className} style={style} onClick={handleClick}>{children}</ReactRouterDom.NavLink>);
    }
    if (href) {
        return (<a href={href} target={target} className={className} style={style} onClick={handleClick}>{children}</a>);
    }
    return (<button className={className} style={style} onClick={handleClick}>{children}</button>);
}

export default Btn;
